import * as React from 'react';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { EditableLabel } from 'src/components/EditableLabel';
import { getProjectTitleTestId } from 'src/constants/testIds';
import {
  getDefaultProjectDataPrefix,
  getDefaultProjectModelPrefix,
} from 'src/containers/ProjectDiagram/utils/generateProjectIri';
import { projectSelector } from 'src/selectors/project';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const ProjectTitle: React.VFC = () => {
  const dispatch = useReduxDispatch();
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  const handleRename = (name: string) => {
    dispatch(projectsActionCreators.renamedProject({ id: projectId, name }));

    if (!project) {
      return;
    }

    if (project.modelNamespace === getDefaultProjectModelPrefix(project)) {
      const modelNamespace = getDefaultProjectModelPrefix({ ...project, name });
      dispatch(
        projectsActionCreators.updatedProjectModelNamespace(
          project.id,
          modelNamespace
        )
      );
    }
    if (project.dataNamespace === getDefaultProjectDataPrefix(project)) {
      const dataNamespace = getDefaultProjectDataPrefix({
        ...project,
        name,
      });
      dispatch(
        projectsActionCreators.updatedProjectDataNamespace(
          project.id,
          dataNamespace
        )
      );
    }
  };

  return (
    <div
      className="sd-project-title"
      data-testid={getProjectTitleTestId(project?.id || '')}
    >
      <EditableLabel onSetValue={handleRename} value={project?.name || ''} />
    </div>
  );
};
